module.exports = __webpack_public_path__ + "img/restless.61afa0eb.svg";